import moment from 'moment'
import AsistenciaApiRepository from '@/modules/pase-lista/infrastructure/AsistenciaApiRepository'
import GetAsistenciaByPersonal from '@/modules/pase-lista/application/GetAsistenciaByPersonal'
import GetAsistenciaByIdAsistencia from '@/modules/pase-lista/application/GetAsistenciaByIdAsistencia'
import GetTipoAsistencia from '@/modules/pase-lista/application/GetTipoAsistencia'
import GetAllTipoServicio from '@/modules/pase-lista/application/GetAllTipoServicio'
import CreateAsistencia from '@/modules/pase-lista/application/CreateAsistencia'
import PatchAsistencia from '@/modules/pase-lista/application/PatchAsistencia'
import UpdateAsistencia from '@/modules/pase-lista/application/UpdateAsistencia'

const repository = new AsistenciaApiRepository()

export default {
  namespaced: true,

  state: {
    asistencias: [],
    asistenciaActual: null,
    tiposAsistencia: [],
    tiposServicio: [],
  },

  getters: {
    getAsistencias: (state) => {
      return state.asistencias
    },
    getAsistenciaActual: (state) => {
      return state.asistenciaActual
    },
    getTiposAsistencia: (state) => {
      return state.tiposAsistencia
    },
    getTiposServicio: (state) => {
      return state.tiposServicio
    },
  },

  mutations: {
    SET_ASISTENCIAS(state, asistencias) {
      state.asistencias = asistencias
    },
    SET_ASISTENCIA_ACTUAL(state, asistencia) {
      state.asistenciaActual = asistencia
    },
    SET_TIPO_ASISTENCIA(state, tipos) {
      state.tiposAsistencia = tipos
    },
    SET_TIPOS_SERVICIO(state, tipos) {
      state.tiposServicio = tipos
    },
  },

  actions: {
    fetchAsistencias: async function ({ commit }, idPersonal) {
      try {
        const asistencias = await new GetAsistenciaByPersonal(repository).execute(idPersonal)
        commit('SET_ASISTENCIAS', asistencias)
      } catch (error) {
        console.log(error)
      }
    },

    fetchAsistenciaById: async function ({ commit }, { idPersonal, idAsistencia }) {
      try {
        const asistencia = await new GetAsistenciaByIdAsistencia(repository).execute(idPersonal, idAsistencia)
        commit('SET_ASISTENCIA_ACTUAL', asistencia)
      } catch (error) {
        console.log(error)
      }
    },

    fetchTipoAsistencia: async function ({ commit }) {
      try {
        const tipos = await new GetTipoAsistencia(repository).execute()
        commit('SET_TIPO_ASISTENCIA', tipos)
      } catch (error) {
        console.log(error)
      }
    },

    fetchTipoServicio: async function ({ commit }) {
      const tiposServicio = await new GetAllTipoServicio(repository).execute()
      commit('SET_TIPOS_SERVICIO', tiposServicio)
    },

    verificarAsistenciaHoy: async function ({ commit }, idPersonal) {
      try {
        const asistencias = await new GetAsistenciaByPersonal(repository).execute(idPersonal)

        const hoy = moment().format('DD/MM/YYYY')

        const asistenciaHoy = asistencias.find((asistencia) => {
          let fechaAsistencia = asistencia.fecha

          if (typeof fechaAsistencia === 'string' && fechaAsistencia.includes(' ')) {
            fechaAsistencia = fechaAsistencia.split(' ')[0]
          }

          return fechaAsistencia === hoy
        })

        return !!asistenciaHoy
      } catch (error) {
        console.log(error)
        return false
      }
    },

    patchSalida: async function ({ commit, state }, { idPersonal, idAsistencia }) {
      try {
        const salidaApi = moment().format('YYYY/MM/DD HH:mm')
        const salidaDisplay = moment().locale('es').format('DD/MM/YYYY hh:mm:ss A'  )
        const payload = { id: idAsistencia, fk_idPersonal: idPersonal, salida: salidaApi }
        await new PatchAsistencia(repository).execute(idPersonal, idAsistencia, payload)
        const updated = state.asistencias.map((a) =>
          a.idAsistencia === idAsistencia ? { ...a, salida: salidaDisplay } : a
        )
        commit('SET_ASISTENCIAS', updated)
        commit('SET_SNACKBAR_MESSAGE', 'Salida registrada correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al registrar la salida.', { root: true })
        console.log(error)
      }
    },

    updateAsistencia: async function ({ commit, dispatch }, { idPersonal, idAsistencia, payload }) {
      try {
        await new UpdateAsistencia(repository).execute(idPersonal, idAsistencia, payload)
        await dispatch('fetchAsistencias', idPersonal)
        commit('SET_SNACKBAR_MESSAGE', 'Asistencia editada correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al editar la asistencia.', { root: true })
        console.log(error)
        throw error
      }
    },

    saveAsistencia: async function ({ commit }, { idPersonal, asistencia }) {
      try {
        await new CreateAsistencia(repository).execute(idPersonal, asistencia)
        commit('SET_SNACKBAR_MESSAGE', 'Asistencia guardada correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al guardar la asistencia.', { root: true })
        console.log(error)
      }
    },
  },
}
